export default __webpack_public_path__ + "static/media/avatar5.d2c5420e.png";